import * as React from 'react';
import LogListCardAdmin from "./LogListCardAdmin";
import I18nUtils from "../../../../I18n/I18nUtils";
import {MenuIcon} from "../../../../Config";
import ScreenCard from '../../../../components/screen/ScreenCard';
import {TR_LOGS} from "../../../../I18n/constants";
import {ROUTE_ADMIN_LOG} from "../../../../routing/Routes";

export default class LogListAdminScreen extends React.Component<{}> {

    public render() {
        return (
            <ScreenCard breadcrumbs={[
                {
                    name: I18nUtils.tr(TR_LOGS),
                    url: ROUTE_ADMIN_LOG,
                    icon: MenuIcon.LOG,
                },
            ]}>
                <LogListCardAdmin/>
            </ScreenCard>
        )
    }
}